<template>
	<v-menu offset-y>
		<template #activator="{ on }">
			<v-btn icon v-on="on" v-if="!isAtaCancelada" @click="openMenu">
				<v-icon class="font-size-grande material-icons">mdi-dots-vertical</v-icon>
			</v-btn>
		</template>
		<v-list class="pa-1">
			<v-list-item
				v-if="isAtaEfetivada"
				class="list-item-height"
				data-testid="action-realinhar"
				@click="$emit('realinhar')"
				:disabled="deveDesabilitarBotaoSeHistoricoInexistente(existeHistorico.acessoHistoricoRealinhar)"
				v-az-auth="permissoes.itemAtaRealinhar"
			>
				<v-icon :size="tamanhoIconeMenu" class="material-icons mr-2">mdi-playlist-edit</v-icon>
				<v-list-item-title class="texto-menu-interno">Realinhar</v-list-item-title>
			</v-list-item>
			<div v-if="isAtaEfetivada">
				<v-list-item
					v-if="opcaoDesbloquearDeveAparecer"
					:disabled="
						deveDesabilitarBotaoSeHistoricoInexistente(existeHistorico.acessoHistoricoBloquearDesbloquear)
					"
					:key="isAtaBloqueada"
					class="list-item-height"
					data-testid="action-bloquear"
					@click="$emit('bloquear')"
					v-az-auth="permissoes.itemAtaDesbloquear"
				>
					<v-icon :size="tamanhoIconeMenu" class="material-icons mr-2">mdi-cancel</v-icon>
					<v-list-item-title class="texto-menu-interno">Desbloquear Item</v-list-item-title>
				</v-list-item>
				<v-list-item
					v-else
					:disabled="
						deveDesabilitarBotaoSeHistoricoInexistente(existeHistorico.acessoHistoricoBloquearDesbloquear)
					"
					:key="isAtaBloqueada"
					class="list-item-height"
					data-testid="action-bloquear"
					@click="$emit('bloquear')"
					v-az-auth="permissoes.itemAtaBloquear"
				>
					<v-icon :size="tamanhoIconeMenu" class="material-icons mr-2">mdi-cancel</v-icon>
					<v-list-item-title class="texto-menu-interno">Bloquear Item</v-list-item-title>
				</v-list-item>
			</div>
			<v-list-item
				v-if="isAtaEfetivada"
				class="list-item-height"
				data-testid="action-alterar-classificacao"
				:disabled="
				deveDesabilitarBotaoSeHistoricoInexistente(existeHistorico.acessoHistoricoAlterarClassificacao)
				"
				v-az-auth="permissoes.itemAtaAlterarClassificacao"
				@click="$emit('alterar-classificacao')"
				>
				<v-icon :size="tamanhoIconeMenu" class="material-icons mr-2">mdi-pencil</v-icon>
				<v-list-item-title class="texto-menu-interno">Alterar Classificação</v-list-item-title>
				</v-list-item>

			<v-list-item
				v-if="isAtaEfetivada"
				class="list-item-height"
				data-testid="action-alterar-alterar-fornecedor"
				:disabled="deveDesabilitarBotaoSeHistoricoInexistente(existeHistorico.acessoHistoricoAlterarFornecedor)"
				@click="$emit('alterar-fornecedor')"
				v-az-auth="permissoes.itemAtaAlterarFornecedor"
			>
				<v-icon :size="tamanhoIconeMenu" class="material-icons mr-2">mdi-pencil</v-icon>
				<v-list-item-title class="texto-menu-interno">Alterar Fornecedor</v-list-item-title>
			</v-list-item>

			<v-list-item
				v-if="isAtaEfetivada"
				class="list-item-height"
				data-testid="action-gerenciar-estoque"
				:disabled="deveDesabilitarBotaoSeHistoricoInexistente(existeHistorico.acessoHistoricoGerenciarSaldo)"
				@click="$emit('gerenciar-estoque')"
				v-az-auth="permissoes.itemAtaSaldoTransferir"
			>
				<v-icon :size="tamanhoIconeMenu" class="material-icons mr-2">mdi-swap-horizontal</v-icon>
				<v-list-item-title class="texto-menu-interno">Remanejar Saldo</v-list-item-title>
			</v-list-item>

			<div v-az-auth="permissoes.ataEditar" v-if="temPermissaoEdicao">
				<v-divider v-if="isAtaEfetivada"></v-divider>

				<v-list-item
					class="list-item-height"
					data-testid="action-excluir"
					@click="$emit('excluir')"
					:disabled="!temPermissaoEdicao"
					v-az-auth="permissoes.itemAtaExcluir"
				>
					<v-icon :size="tamanhoIconeMenu" class="material-icons mr-2">mdi-delete</v-icon>
					<v-list-item-title class="texto-menu-interno">Excluir</v-list-item-title>
				</v-list-item>
			</div>
		</v-list>
	</v-menu>
</template>
<script>
import { actionTypes, getterTypes, mutationTypes } from '@/core/constants'
import { mapActions, mapMutations, mapState } from 'vuex'
import validacaoAta from '@/views/mixins/validacaoAta'
import permissoesMixin from '@/views/mixins/permissoes-mixin'

export default {
	name: 'acessar-ata-itens-btn-acoes',
	mixins: [validacaoAta, permissoesMixin],
	props: {
		item: {
			type: Object,
			required: true,
		},
		isAtaBloqueada: {
			type: Boolean,
		},
	},
	data() {
		return {
			tamanhoIconeMenu: '18px',
			existemTodosOsHistoricos: false,
		}
	},
	computed: {
		...mapState({
			existeHistorico: (state) => state.itemAta.existeHistorico,
			informacoesAta: (state) => state.ata.informacoesAta,
		}),
		opcaoDesbloquearDeveAparecer() {
			return (
				this.item.isBloqueado &&
				(this.existeHistorico.acessoHistoricoBloquearDesbloquear || !this.isAtaBloqueada)
			)
		},
		isAtaEfetivada() {
			return (
				(this.informacoesAta && this.estaEfetivado(this.informacoesAta)) ||
				(this.informacoesAta && this.ehHistoricoProrrogacao(this.informacoesAta))
			)
		},
		isAtaCancelada() {
			return this.estaCancelada(this.informacoesAta)
		},
	},
	methods: {
		...mapActions({
			buscarAcessoHistoricoBotoes: actionTypes.ITEM_ATA.BUSCAR_ACESSO_HISTORICO_BOTOES,
		}),
		...mapMutations({
			setHistoricos: mutationTypes.ITEM_ATA.SET_HISTORICOS,
		}),
		async openMenu() {
			this.existemTodosHistoricos()

			if (!this.existemTodosOsHistoricos) {
				const { data } = await this.buscarAcessoHistoricoBotoes(this.item.id)
				this.setHistoricos(data)
			}
		},
		existemTodosHistoricos() {
			if (!this.existemTodosOsHistoricos) {
				this.existemTodosOsHistoricos = this.$store.getters[getterTypes.ITEM_ATA.EXISTE_TODOS_HISTORICOS_ITEM]
			}
		},
		deveDesabilitarBotaoSeHistoricoInexistente(existeHistorico) {
			return !this.temPermissaoEdicao && !existeHistorico
		},
	},
}
</script>
<style scoped lang="stylus">
.font-size-grande
	font-size 28px !important

.texto-menu-interno
	font-size 0.8em

.list-item-height
	min-height 0 !important

.v-list-item--disabled
	cursor not-allowed !important
</style>
